/**
 * With the accordion module content gets folded vertically to save space and
 * allow a better overview of the complete content at hand. The user can
 * choose to view content by clicking on the appropriate accordion header.
 *
 * @module Accordion
 * @requires Velocity
 * @requires Velocity UI
 * @return {Object} public methods
 */

const Accordion = (function() {

	/**
	 * Initializes this module.
	 */
	function init() {

		// Don't even bother when there are no accordions
		if (document.querySelector('.accordion') === null) return false;

		addListeners();
		setInitialState();
	}

	/**
	 * Sets up listeners for user actions.
	 */
	function addListeners() {
		var headerElements = document.querySelectorAll('.accordion__header');

		for (var i = 0; i < headerElements.length; i++) {
			headerElements.item(i).onclick = onHeaderClick;
		}
	}

	/**
	 * Sets up initial state for this module.
	 */
	function setInitialState() {
		checkForHash();
		//addCloseButtons();
		closeItems();
	}

	/**
	 * Gets called when a header got clicked on.
	 * @param {MouseEvent} e
	 */
	function onHeaderClick(e) {
		var headerElement = this;

		e.preventDefault();

		// Prevent further clicks on the header while it is animating
		if (headerElement.classList.contains('is-animating')) {
			return false;
		} else {
			headerElement.classList.add('is-animating');
		}

		toggleContent(headerElement);

		return false;
	}

	/**
	 * Opens the content when the item is currently closed or closes the content
	 * when it is currently open.
	 * @param {Element} headerElement which has an active state or not.
	 */
	function toggleContent(headerElement) {
		if (headerElement.classList.contains('is-active')) {
			closeContent(headerElement.nextElementSibling);
			headerElement.classList.remove('is-active');
		} else {
			openContent(headerElement.nextElementSibling);
			headerElement.classList.add('is-active');
		}
	}

	/**
	 * Opens the content with an animation.
	 * @param {Element} contentElement is the element that should be opened.
	 */
	function openContent(contentElement) {
		$(contentElement).velocity('transition.slideLeftIn', {
			duration: 300,
			complete: function() {
				contentElement.previousElementSibling.classList.remove('is-animating');
			}
		});
	}

	/**
	 * Closes the content with an animation.
	 * @param {Element} contentElement is the element that should be closed.
	 */
	function closeContent(contentElement) {
		$(contentElement).velocity('transition.slideLeftOut', {
			duration: 200,
			complete: function() {
				contentElement.previousElementSibling.classList.remove('is-animating');
			}
		});
	}

	/**
	 * If a hash fragment identifier at the end of the URL matches the id of an
	 * item, that item is displayed as open.
	 */
	function checkForHash() {
		if (window.location.hash !== '') {
			var id = window.location.hash.substring(1);
			var itemElement = document.getElementById(id);

			if (itemElement !== null) {
				var contentElement = itemElement.querySelector('.accordion__content');
				if(contentElement !== null) contentElement.classList.add('is-initially-open');
			}
		}
	}

	/**
	 * Closes all items except for the ones that should be initially open.
	 */
	function closeItems() {
		var contentElements = document.querySelectorAll('.accordion__content');

		for (var i = 0; i < contentElements.length; i++) {
			var contentElement = contentElements.item(i);

			if (! contentElement.classList.contains('is-initially-open')) {
				contentElement.style.display = 'none';
			} else if(contentElement.classList.contains('is-initially-open')) {
				contentElement.previousElementSibling.classList.add('is-active');
				contentElement.classList.remove('is-initially-open');
			}
		}
	}

	/**
	 * Adds a close buttons to each accordion item to enable users with small
	 * screens to close long content more easily.
	 */
	function addCloseButtons() {
		if (matchMedia('only screen and (max-width: 500px)').matches) {
			var contentElements = document.querySelectorAll('.accordion__content');
			for (var i = 0; i < contentElements.length; i++) {
				var button = document.createElement('button');
				button.classList.add('button');
				button.classList.add('button--alternative');
				button.classList.add('accordion__close-button');
				button.addEventListener('click', onCloseButtonClicked, false);
				contentElements.item(i).appendChild(button);
			}
		}
	}

	/**
	 * Gets called when the close button get clicked.
	 * @param {MouseEvent} e
	 * @return {Boolean} false
	 */
	function onCloseButtonClicked(e) {
		var headerElement = this.parentNode.previousElementSibling;

		$(headerElement).velocity('scroll', {
			duration: 300,
			complete: function () {
				toggleContent(headerElement);
			}
		});

		return false;
	}

	// Return public methods
	return {
		init: init
	};

})();

window.Accordion = Accordion;
export default Accordion;
